import { getInitials } from '@/shared/utils/getInitials';
import { useIsSuperUser } from '@/features/access-control';
import { useUserInfo } from '@/features/space-user';

export const useTopBarIdentity = () => {
	const { data: userInfo } = useUserInfo();
	const isSuperUser = useIsSuperUser();

	const fullName = userInfo?.userName ?? '';

	return {
		idUser: userInfo?.userId ?? '',
		isSuperUser,
		companyName: userInfo?.companyName,
		initials: getInitials(fullName),
	};
};
